import React, {useEffect} from "react";
import { Nav, Navbar} from "react-bootstrap";
import {Link} from "react-router-dom";
import logo from "../../images/logo.svg";
import bell from "../../images/bell.svg";
import noIconProfile from "../../images/iconProfile.svg";
import styled from "styled-components";
import { Dropdown, Avatar, MenuProps } from "antd";
import useToken from '../../hooks/useToken';
import { Chat } from "../Chat/Chat";

const Styles = styled.div`
  a, .navbar-brand, .navbar-nav .nav-link {
      font-size: 14px;
      
      &:hover {
          color: #2196F3;
      }
  }

  #chatNav {
    margin-right: 17px;
  }
  
  // @media (max-width: 766px) {
  //   #chatNav {
  //     margin-right: 0;
  //   }

  //   .navbar-nav .ant-avatar {
  //     display: none;
  //   }
  // }
`

export default function StudentsNavbar(){
  const { deleteToken } = useToken();

  const iconProfile = localStorage.getItem('iconProfile') || noIconProfile;

  const items: MenuProps['items'] = [
    {
      key : "1",
      label : (
        <Link to="/home" style={{paddingRight : "30px"}}>Аккаунт</Link>
      )
    },
    {
      type: 'divider',
    },
    {
      key : "2",
      label: 'Выйти',
      onClick: deleteToken
    },
  ];

  return (
    <Styles>
      <Navbar collapseOnSelect className='justify-content-between' expand="md" bg="white" variant="white">
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Brand>
          <Link to="/"> 
            <img src={logo} height="74px" width="115px" className="logo" alt=""/> 
          </Link>
        </Navbar.Brand>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/" id="vacancies"> Вакансии </Nav.Link>
            <Nav.Link href="/replies" id="replies"> Отклики и приглашения </Nav.Link>
            <Nav.Link href="/events" id="events"> События </Nav.Link>
          </Nav>
        </Navbar.Collapse>
        {/* <img src={bell} style={{marginRight: '17px', cursor:'pointer'}}/> */}
        <Nav className='d-flex flex-row justify-content-end align-items-center'>
          <div style={{marginRight: '17px'}} id="chatNav">
            <Chat />
          </div>
          <Dropdown menu={{ items }} trigger={['click']}>
            <Avatar src={iconProfile} style={{cursor:'pointer'}}/>
          </Dropdown>
        </Nav>
      </Navbar>
    </Styles>
  )
}